/**
 * File Name          : drive-item.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export enum DRIVE_ITEM_TYPE {
    NA = 0,
    FILE_ITEM = 1,
    DIR_ITEM = 2,
    END_OF_DIR = 3
}

export interface Drive_Item {
    // index: number;
    type: DRIVE_ITEM_TYPE;
    size: number;
    name: string;
    children?: Drive_Item[];
    path?: string; // Full path of the item
    deleted?: boolean; // Flag to indicate if the item is deleted
}